import { BookingTable } from "@/app/Dashboard/Components/BookingTable";
import { useRelocationRecord } from "@/app/Relocations/Hooks/useRelocationRecord";
export function RelocationBookingScreen() {
  const relocation = useRelocationRecord();
  return (
    <div className="py-6">
      <BookingTable
        id="relocation-bookings"
        title="Bookings"
        queryVariables={{
          relocationId: relocation.id,
        }}
      />
    </div>
  );
}
